import { memo } from 'react'
import { Trans } from 'react-i18next'

import Text from '../text/Text'
import { formatTicks } from '../../../util/string.helpers'
import StatusUpgradeItem from './StatusUpgradeItem'

const StatusItem = ({ t, symbol, pointCost, ...restProps }) => {
  return (
    <StatusUpgradeItem
      t={t}
      label='membership.upgrade'
      subtitle={
        <Text
          label={
            // @TODO: Updated this for en.json#568
            // "price-info": "<strong>Price:</strong> ${{usd}} or {{points}} {{symbol}}",
            <Trans
              i18nKey='membership.price-info'
              values={{
                // usd: formatTicks(usd),
                points: formatTicks(pointCost || 0),
                symbol
              }}
            />
          }
          color='inherit'
        />
      }
      {...restProps}
    />
  )
}

export default memo(StatusItem)
